import * as React from 'react';
import moment from 'moment';

import { connect } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';

import { throttle } from 'lodash';

interface IExternalProps {
}

interface StateToProps {
    appearanceOffset: number;
}

interface IScrollToTopState {
    showButton: boolean;
}

type ScrollToTopProps = IExternalProps & StateToProps;

/**
 * Displays below a configured scroll position.
 * 
 * Clicking the button triggers a scroll to the top of the calendar.
 */
class ScrollToTopBase extends React.Component<ScrollToTopProps, IScrollToTopState> {
    public showButton = false;

    constructor(props) {
        super(props);
        this.state = {
            showButton: false
        }
    }

    /**
     * Update state to check whether this component should show (based on scroll position)
     */
    checkScroll() {
        this.setState({
            showButton: window.pageYOffset > this.props.appearanceOffset
        })
    }

    private boundScroll = throttle(this.checkScroll.bind(this), 50);

    componentWillUnmount() {
        window.removeEventListener('scroll', this.boundScroll.bind(this));
    }

    componentDidMount() {
        this.checkScroll();
        window.addEventListener('scroll', this.boundScroll);
    }

    shouldComponentUpdate(nextProps: ScrollToTopProps, nextState: IScrollToTopState) {
        return this.state.showButton !== nextState.showButton;
    }

    render() {
        return (
            <a href="#main" className="ace-cal-back-to-top icon-btn" data-show-button={this.state.showButton}>
                <p className="visually-hidden">
                    Top
                </p>
                <span className="footer-top-btn-icon">
                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-arrow-up" />
                    </svg>
                </span>
            </a>
        )
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        appearanceOffset: state.calendarSettings.scrollToTopAppearanceOffset
    }
}

export default connect(mapStateToProps)(ScrollToTopBase);